import { createReducer } from 'redux-starter-kit';
import { loadAppConfig, saveAppConfig, saveBusinessDetails } from './appConfigUiActions';
import { selectRequest } from '../../domain/requests/RequestReducer';


/**
 * A Selector for the loadAppConfig request
 */
export const selectLoadAppConfigRequest = (state, configCode) => {
  const requestId = state.via.ui.appConfig[configCode];
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the saveBusinessDetails request
 */
export const selectSaveBusinessDetailsRequest = (state) => {
  const requestId = state.via.ui.appConfig.saveBusinessDetailsId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the loadAppConfig request
 */
export const selectUpdateAppConfigRequest = (state, configCode) => {
  const requestId = state.via.ui.appConfig[`UPDATE_${configCode}`];
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialAppConfigState = {
  saveBusinessDetailsId: null,
  // map of app config codes to their load request ids
};

/**
 * A reducer for application configuration requests.
 */
const appConfigUiReducer = createReducer(initialAppConfigState, {

  [loadAppConfig]: (state, action) => ({
    ...state,
    [action.payload.configCode]: action.payload.requestId,
  }),

  [saveAppConfig]: (state, action) => ({
    ...state,
    [`UPDATE_${action.payload.configName}`]: action.payload.requestId,
  }),

  [saveBusinessDetails]: (state, action) => ({
    ...state,
    saveBusinessDetailsId: action.payload,
  }),
});

export default appConfigUiReducer;
